import { render, staticRenderFns } from "./ber.vue?vue&type=template&id=593c18d4&"
import script from "./ber.vue?vue&type=script&lang=js&"
export * from "./ber.vue?vue&type=script&lang=js&"
import style0 from "./ber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports